import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/landing/lg/overview.png'
import _imports_1 from '@/assets/landing/md/overview.png'
import _imports_2 from '@/assets/landing/sm/overview.png'
import _imports_3 from '@/assets/landing/lg/charts.png'
import _imports_4 from '@/assets/landing/md/charts.png'
import _imports_5 from '@/assets/landing/sm/charts.png'
import _imports_6 from '@/assets/landing/lg/gizmo.png'
import _imports_7 from '@/assets/landing/md/gizmo.png'
import _imports_8 from '@/assets/landing/sm/gizmo.png'


const _hoisted_1 = _imports_0
const _hoisted_2 = _imports_1
const _hoisted_3 = _imports_2
const _hoisted_4 = _imports_3
const _hoisted_5 = _imports_4
const _hoisted_6 = _imports_5
const _hoisted_7 = _imports_6
const _hoisted_8 = _imports_7
const _hoisted_9 = _imports_8
const _hoisted_10 = { class: "flex flex-col py-8 md:py-32 px-2 md:px-20 space-y-24" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"prose-2xl text-center mb-12\"><p class=\"text-3xl pt-12 lg:pt-0\"><strong>Hey!</strong></p><p> Are you curious about what NEAR account activity looks like in chart form?<br>Well, then, you&#39;re in luck, because <strong>stats.gallery</strong> is here for you! </p></div><div class=\"prose-2xl text-center\"><h2 class=\"font-bold\">Informative overview</h2><picture><source media=\"(min-width: 768px)\" srcset=\"" + _hoisted_1 + "\"><source media=\"(min-width: 480px)\" srcset=\"" + _hoisted_2 + "\"><source media=\"(min-width: 0px)\" srcset=\"" + _hoisted_3 + "\"><img src=\"" + _imports_2 + "\" style=\"margin:0 auto;\"></picture></div><div class=\"prose-2xl text-center\"><h2 class=\"font-bold\">Descriptive charts &amp; graphs</h2><picture><source media=\"(min-width: 768px)\" srcset=\"" + _hoisted_4 + "\"><source media=\"(min-width: 480px)\" srcset=\"" + _hoisted_5 + "\"><source media=\"(min-width: 0px)\" srcset=\"" + _hoisted_6 + "\"><img src=\"" + _imports_5 + "\" style=\"margin:0 auto;\"></picture></div>", 3)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "prose-2xl" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-bold text-center pb-12" }, "Also,")
], -1)
const _hoisted_15 = { class: "flex flex-wrap lg:space-x-24 w-full items-center lg:items-start justify-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("picture", null, [
  /*#__PURE__*/_createElementVNode("source", {
    media: "(min-width: 768px)",
    srcset: _hoisted_7
  }),
  /*#__PURE__*/_createElementVNode("source", {
    media: "(min-width: 480px)",
    srcset: _hoisted_8
  }),
  /*#__PURE__*/_createElementVNode("source", {
    media: "(min-width: 0px)",
    srcset: _hoisted_9
  }),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_8 })
], -1)
const _hoisted_17 = { class: "flex flex-wrap max-w-2xl" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "History", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "See all of your progress in one place!", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Resources", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Guides and tutorials from around the network!", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Quests", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "Get and complete quests to pump your account up!", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Transactions", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, "Meticulous records of each and every on-chain action!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_10, [
    _hoisted_11,
    _createElementVNode("div", null, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_Card, { title: "History" }, {
            default: _withCtx(() => [
              _hoisted_18,
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_Card, { title: "Resources" }, {
            default: _withCtx(() => [
              _hoisted_20,
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_Card, { title: "Quests" }, {
            default: _withCtx(() => [
              _hoisted_22,
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(_component_Card, { title: "Transactions" }, {
            default: _withCtx(() => [
              _hoisted_24,
              _hoisted_25
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}